import { render, staticRenderFns } from "./LoanRequestsView.vue?vue&type=template&id=5fe48e62&scoped=true&"
import script from "./LoanRequestsView.vue?vue&type=script&lang=js&"
export * from "./LoanRequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe48e62",
  null
  
)

export default component.exports